import { useAiEditorContext } from '../ai-editor.context';

import { AiEditorBlock } from './ai-editor-block';

export const AiEditorContent = () => {
  const {
    originalText,
    result,
    isGenerating,
    replaceOnResult,
    showAddEmojiOption,
    addEmoji,
    handleAddEmoji,
  } = useAiEditorContext();

  if (replaceOnResult) {
    return (
      <AiEditorBlock
        title={result ? 'Результат' : 'Оригинал'}
        content={result ?? originalText}
        loading={!result && isGenerating}
        showEmojiCheckbox={showAddEmojiOption}
        addEmoji={addEmoji}
        onAddEmoji={handleAddEmoji}
      />
    );
  }

  return (
    <>
      <AiEditorBlock
        title="Оригинал"
        content={originalText}
        copyIcon={false}
        collapsible={!!result}
      />

      {(isGenerating || !!result) && (
        <AiEditorBlock
          title="Результат"
          content={result ?? originalText}
          loading={isGenerating}
        />
      )}
    </>
  );
};
